@import url(../../common/css/base.css);

.review_rate_section {
  padding: 0 20px;
  align-items: flex-end;
}

.sort-box {
  align-items: baseline;
}
.dropdown-menu {padding: 0;}
.sort-box span {
  font-size: 14px;
  color: #333;
}

.areviews_rating_filter {
  margin-bottom: 4px;
  cursor: pointer;
  transition: all .3s;
}
.areviews_rating_filter:last-child {
  margin-bottom: 0;
}
.areviews_rating_filter>.flex {
  height: 20px;
  font-size: 14px;
  color: #fdcc0d;
}
.areviews_rating_filter.active>.flex {
  color: #fd5000;
}

.icon-star {
  width: 18px;
  height: 20px;
  line-height: 20px;
  padding-left: 2px;
}
.icon-star svg path {
  fill: #9c9c9c;
}

.progress_bar_con {
  width: 140px;
  height: 12px;
  background-color: #d8d8d8;
  margin-left: 8px;
  position: relative;
}
.progress_bar_inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fdcc0d;
  transform-origin: left center;
  transform: scaleX(var(--percent));
  transition: all .2s;
}
.areviews_rating_filter.active .progress_bar_inner {
  background: #fd5000;
}
.progress_bar_con.no_reviews {
  background-color: #d8d8d8;
}

.total_reviews_number_Rating {
  color: #fdcc0d;
  transition: all .2s;
}
.areviews_rating_filter.active .total_reviews_number_Rating {
  color: #fd5000;
}
.total_reviews_number_Rating span {
  display: inline-block;
  font-size: 14px;
  width: 50px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
  border: 1px solid #efefef;
  border-radius: 12px;
}

#jackery-comment-header_wrapper .flex {align-items: baseline;}

@media screen and (max-width: 1024px) {
  .review_rate_section {
    padding: 0;
  }

  .areviews_rating_filter {
    width: 100%;
  }

  .progress_bar_con {
    width: unset;
    flex: 1;
  }
}